export * from './delete-tour-status.service';
export * from './delete-tour-status.service.module';